<template>
  <div class="pc-list" ref="list">
      <h1>学者列表</h1>
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteMagazineScholarInit">删除</button>
          <span></span>
          <button @click="addMagazineScholar">添加</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="scholarList"
    >
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="scholarList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="头像" width="180" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.image" :src="scope.row.image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="name"
        label="姓名"
        sortable="custom"
        width="160"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.name ? scope.row.name : "" }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="university" label="所属院校" width="260">
        <template slot-scope="scope">
          <div v-if="scope.row.university">
            {{ scope.row.university ? scope.row.university : "" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="职位" width="320">
        <template slot-scope="scope">
          <div v-if="scope.row.title">
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="230">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog class="designerDialog" 
      :title="ScholarDetail.name"
    :visible.sync="isUpdateShow" width="30%">
      <el-form label-width="80px">
        <el-form-item label="图片">
          <UploadImage
            :img="ScholarDetail.image"
            :width="200"
            :height="160"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </el-form-item>
                <el-form-item label="名称">
          <el-input
            v-model="ScholarDetail.name"
            
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="职位">
          <el-input
            v-model="ScholarDetail.title"
            
            placeholder="请输入职位"
          ></el-input>
        </el-form-item>
        <el-form-item label="院校">
          <el-input
            v-model="ScholarDetail.university"
            
            placeholder="请输入院校"
          ></el-input>
        </el-form-item>
        <el-form-item label="简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="ScholarDetail.intro"
            
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(ScholarDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="scholarList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
    <!-- @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage" -->
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import DeleteHint from "@/components/template/DeleteHint";
import UploadImage from "../../../componentSet/uploadImage.vue";
import {
  scholarList_Api,
  updateScholarDetail_Api,
  deleteScholarList_Api,
  getScholarDetail_Api,
  setScholarDetail_Api,
} from "@/apis/magazine.api";
export default {
  components: {
    Pagination,
    DeleteHint,
    UploadImage,
  },
  data() {
    return {
      loading: false,
      isUpdateShow: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      ScholarDetail: {
        image: "",
        scholar_id: null,
      },
      isSelectAll: false,
      scholarList: [],
      checked: [],
    };
  },
  mounted() {
    this.getScholarListByRules(this.searchRules);
  },
  methods: {
    getUploadImage(img_url) {
      this.ScholarDetail.image = img_url;
    },
    // 获取
    getScholarListByRules(data) {
      this.loading = true;
      scholarList_Api(data)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.data.length);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.scholarList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.checked = [];
        this.scholarList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.scholarList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getScholarListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      this.isUpdateShow = true;
      getScholarDetail_Api(item.id).then((res) => {
        this.ScholarDetail = res.data;
        this.ScholarDetail.scholar_id = this.ScholarDetail.id;
        this.ScholarDetail.name = this.ScholarDetail.name;
        console.log(res);
      });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getScholarListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      return data;
    },
    isDelete() {
      let delete_ids = { scholar_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteScholarList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getScholarListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },

    submitBanner(item) {
      if (this.ScholarDetail.id == null) {
        setScholarDetail_Api(this.ScholarDetail).then((res) => {
          console.log(res);
          this.getScholarListByRules();
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        updateScholarDetail_Api(this.ScholarDetail).then((res) => {
          this.getScholarListByRules();
          console.log(res);
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    // 删除学者
    deleteMagazineScholarInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的学者！", null);
      }
    },
    // 添加学者
    addMagazineScholar() {
      this.isUpdateShow = true;
      for (let key in this.ScholarDetail) {
        this.ScholarDetail[key] = null;
      }
        this.ScholarDetail.status = 0;
    },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getScholarListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .el-upload__tip{
    margin-top: -7px
}
  /deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/guihua/components/MagazineScholarTable.vue